import * as firebase from 'firebase';

const config = {
    apiKey: 'AIzaSyDvKRFRsIBIogsfLI_dYKrjjHakOwZ8pjY',
    authDomain: 'iam-student.firebaseapp.com',
    databaseURL: 'https://iam-student.firebaseio.com',
    projectId: 'iam-student',
    storageBucket: 'iam-student.appspot.com',
    messagingSenderId: '94298341277',
    appId: '1:94298341277:web:dd27cae6592fa624'
};

firebase.initializeApp(config);

export const databaseRef = firebase.database();
export const firebaseAuth = firebase.auth();
export const firebaseStorage = firebase.storage();
